export default __webpack_public_path__ + "static/media/cross_icon.4affa5d5.svg";